import { z } from "zod";
export const REFERENCE_STATUSES = ["REQUESTED", "SUBMITTED", "DECLINED", "EXPIRED"];
/** Student nominates a referee from the coordinator-maintained staff directory. */
export const referenceRequestSchema = z.object({
    refereeUserId: z.string().uuid(),
    message: z.string().trim().max(2000).optional().or(z.literal("")),
});
/**
 * Minimum viable reference: a yes/no recommendation, optionally with comments.
 * A supporting PDF letter is uploaded separately via /api/files/reference-letter.
 * `confidential` (the default) hides the result from the student.
 */
export const referenceSubmissionSchema = z.object({
    recommend: z.boolean(),
    comments: z.string().trim().max(8000).optional().or(z.literal("")),
    confidential: z.boolean().default(true),
    answers: z.record(z.string(), z.unknown()).default({}),
});
